export const ALL_LANGUAGES = [
  {
    abbr: 'en',
    lang: 'en-US',
    language: 'English',
    locale: 'en',
    languageInEn: 'English',
  },
  {
    abbr: 'es',
    lang: 'es-ES',
    language: 'Español',
    locale: 'es-ES',
    languageInEn: 'Spanish',
  },
  {
    abbr: 'fr',
    lang: 'fr-FR',
    language: 'Français',
    locale: 'fr-FR',
    languageInEn: 'French',
  },
  {
    abbr: 'pt',
    lang: 'pt-PT',
    language: 'Português',
    locale: 'pt-PT',
    languageInEn: 'Portuguese',
  },
  {
    abbr: 'it',
    lang: 'it-IT',
    language: 'Italiano',
    locale: 'it-IT',
    languageInEn: 'Italian',
  },
  {
    abbr: 'ja',
    lang: 'ja-JP',
    language: '日本語',
    locale: 'ja-JP',
    languageInEn: 'Japanese',
  },
  {
    abbr: 'th',
    lang: 'th-TH',
    language: 'ภาษาไทย',
    locale: 'th-TH',
    languageInEn: 'Thai',
  },
  {
    abbr: 'pl',
    lang: 'pl-PL',
    language: 'Polski',
    locale: 'pl-PL',
    languageInEn: 'Polish',
  },
  {
    abbr: 'ko',
    lang: 'ko-KR',
    language: '한국어',
    locale: 'ko-KR',
    languageInEn: 'Korean',
  },
  {
    abbr: 'de',
    lang: 'de-DE',
    language: 'Deutsch',
    locale: 'de-DE',
    languageInEn: 'German',
  },
  {
    abbr: 'ru',
    lang: 'ru-RU',
    language: 'Русский',
    locale: 'ru-RU',
    languageInEn: 'Russian',
  },
  {
    abbr: 'da',
    lang: 'da-DK',
    language: 'Dansk',
    locale: 'da-DK',
    languageInEn: 'Danish',
  },
  {
    abbr: 'ar',
    lang: 'ar-AE',
    language: 'العربية',
    locale: 'ar-AE',
    languageInEn: 'Arabic',
  },
  {
    abbr: 'nb',
    lang: 'nb-NO',
    language: 'Norsk bokmål',
    locale: 'nb-NO',
    languageInEn: 'Norwegian',
  },
  {
    abbr: 'nl',
    lang: 'nl-NL',
    language: 'Nederlands',
    locale: 'nl-NL',
    languageInEn: 'Dutch',
  },
  {
    abbr: 'id',
    lang: 'id-ID',
    language: 'Bahasa Indonesia',
    locale: 'id-ID',
    languageInEn: 'Indonesian',
  },
  {
    abbr: 'tw',
    lang: 'zh-Hant-TW',
    language: '繁體中文',
    locale: 'zh-Hant-TW',
    languageInEn: 'Chinese_Traditional',
  },
  {
    abbr: 'zh',
    lang: 'zh-CN',
    language: '简体中文',
    locale: 'zh-CN',
    languageInEn: 'Chinese_Simplified',
  },
  {
    abbr: 'tr',
    lang: 'tr-TR',
    language: 'Türkçe',
    locale: 'tr-TR',
    languageInEn: 'Turkish',
  },
] as const

export type I18nAbbr = (typeof ALL_LANGUAGES)[number]['abbr']
